import { useI18n } from '../../i18n/I18nContext'
import { stateHeadlines } from '../../i18n/stateHeadlines'
import RecoveryShell from '../../components/ui/RecoveryShell'
import { Button } from '../../components/ui/Primitives'

export default function OfflinePage({ onRetry = () => window.location.reload() }: { onRetry?: () => void }) {
    const { t, language } = useI18n()
    return <RecoveryShell title={t('errorPage.offline.title')} headline={stateHeadlines(language).offline} sentence={t('errorPage.offline.body')}>
        <Button onClick={onRetry}>{t('errorPage.offline.retry')}</Button>
    </RecoveryShell>
}
